/**
 * Popover
 * @requires https://getbootstrap.com
 * @requires https://popper.js.org/
*/

import { Popover } from "bootstrap";

const popover = (() => {

  let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));

  let popoverList = popoverTriggerList.map((popoverTriggerEl) => new Popover(popoverTriggerEl));

})();

export default popover;
